import LocalStorageConstants from "../constants/LocalStorageConstants";

export const loadToken = () => {
  const token = localStorage.getItem(LocalStorageConstants.LOCAL_STORAGE_TOKEN);
  if (!token || token === undefined) return null;

  return JSON.parse(token);
};

export const saveToken = (token) => {
  if (token)
    localStorage.setItem(
      LocalStorageConstants.LOCAL_STORAGE_TOKEN,
      JSON?.stringify(token)
    );
};

export const removeToken = () => {
  localStorage.removeItem(LocalStorageConstants.LOCAL_STORAGE_TOKEN);
};

export const loadRefreshToken = () => {
  return localStorage.getItem(LocalStorageConstants.LOCAL_REFRESH_TOKEN);
};

export const saveRefreshToken = (token) => {
  localStorage.setItem(LocalStorageConstants.LOCAL_REFRESH_TOKEN, token);
};

export const removeRefreshToken = () => {
  localStorage.removeItem(LocalStorageConstants.LOCAL_REFRESH_TOKEN);
};
